// Maps between the Spanish (canonical, no prefix) and English (/en prefix) versions
// of the pages that have a REAL bilingual route: home, all product pages, projects
// (index + individual detail pages), patents, challenges, strategy, contact and team
// (including individual member profiles).

const STATIC_PAIRS = [
  ['/', '/en'],
  ['/tristrash', '/en/tristrash'],
  ['/pando', '/en/pando'],
  ['/lixo', '/en/lixo'],
  ['/halo-i', '/en/halo-i'],
  ['/digital-twin', '/en/digital-twin'],
  ['/canaria', '/en/canaria'],
  ['/exoesqueleto', '/en/exoesqueleto'],
  ['/robotica', '/en/robotica'],
  ['/klinloop', '/en/klinloop'],
  ['/equipo', '/en/team'],
  ['/proyectos', '/en/projects'],
  ['/patentes', '/en/patentes'],
  ['/retos', '/en/challenges'],
  ['/estrategia', '/en/strategy'],
  ['/contacto', '/en/contact'],
];

export function isEnglishPath(pathname) {
  return pathname === '/en' || pathname.startsWith('/en/');
}

// Given the current pathname, returns the equivalent path in the other language,
// or null if this page has no bilingual counterpart.
export function getCounterpartPath(pathname) {
  const esTeamMatch = pathname.match(/^\/equipo\/([^/]+)$/);
  if (esTeamMatch) return `/en/team/${esTeamMatch[1]}`;

  const enTeamMatch = pathname.match(/^\/en\/team\/([^/]+)$/);
  if (enTeamMatch) return `/equipo/${enTeamMatch[1]}`;

  const esProjectMatch = pathname.match(/^\/proyectos\/([^/]+)$/);
  if (esProjectMatch) return `/en/projects/${esProjectMatch[1]}`;

  const enProjectMatch = pathname.match(/^\/en\/projects\/([^/]+)$/);
  if (enProjectMatch) return `/proyectos/${enProjectMatch[1]}`;

  for (const [es, en] of STATIC_PAIRS) {
    if (pathname === es) return en;
    if (pathname === en) return es;
  }
  return null;
}
